import { ProgramEnrollment, ProgramTemplate } from '@entities/program/types/template'

export const getWeeksAmount = (
	data: ProgramTemplate | ProgramEnrollment | null | undefined
): number => {
	if (!data || !data.plan || !data.plan.weeks) {
		return 0
	}
	return Object.keys(data.plan.weeks).length
}
